import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import axios from "axios";
import {config} from "../utils/Constants";
import { useSelector } from "react-redux";

const URL = config.url;
const isMobileLogin = sessionStorage.getItem("IsMobileLogIn");


const initialState = {
    loading: "idle",
    flag: null,
    responseTitle: null,
    responseDescription: null,
    error: null,
    info: {},
    isPopup: false,
    transactionsToApproveCount: 0,

};

export const fetchTransactionsToApproveCount = createAsyncThunk(
    "Overview/GetTransactionsToApproveCount",
    async () => {
      let req; 
      let token;
      if (isMobileLogin) {
        req = new BaseRequest(sessionStorage.getItem("SessionMobile"));
        token = sessionStorage.getItem("TokenMobile");
      } else {
        req = new BaseRequest(sessionStorage.getItem("SessionID"));
        token = sessionStorage.getItem("Token");

      }

      const res = await axios.post(
        `${URL}/v1/Overview/GetTransactionsToApproveCount`,
        req,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      
      return res.data;
    }
  );
  
const responseSlice = createSlice({
    name: "response",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setFlag: (state, action) => {
            state.flag = action.payload;
        },
        setResponseTitle: (state, action) => {
            state.responseTitle = action.payload;
        },
        setResponseDescription: (state, action) => {
            state.responseDescription = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setResponseInfo: (state, action) => {
            state.info = action.payload;
        },
        setIsPopup: (state, action) => {
            state.isPopup = action.payload;
        },
        resetResponseState: (state) => {
            state.loading = "idle";
            state.flag = null;
            state.responseTitle = null;
            state.responseDescription = null;
            state.error = null;
            state.info = {};
            state.isPopup = false;
        }
    },
    extraReducers: (builder)=>{
        // builder.addCase(fetchTransactionsToApproveCount.pending, (state) => {
        //     state.loading = "pending";
        // });
        builder.addCase(fetchTransactionsToApproveCount.fulfilled, (state, action) => {
            // state.loading = "idle";
            state.transactionsToApproveCount = action.payload?.Payload?.CountTrxs;
        });
        builder.addCase(fetchTransactionsToApproveCount.rejected, (state, action) => {
            // state.loading = "idle";
            state.error = action.error.message;
        });
    }
})

export const { setLoading, setFlag, setResponseTitle, setResponseDescription, resetResponseState, setIsPopup, setResponseInfo} = responseSlice.actions;
export default responseSlice.reducer;